<template>
  <div>
    <Modal v-model="visible" :title="$units.isOkBao() ? '批量操作' : '批量审核'" :mask-closable="false" :footer-hide="true" width="500px" class="my-modal top">
      <loading :isShow="loading" />
      <div class="confirm-box">
        <div style="margin-bottom: 20px">已选择{{ detail.checkCount }}条申请中/待打款的记录</div>
        <div style="margin-bottom: 20px">结算主体：{{ detail.settlementEntity }}</div>
        <div>
          <span>合计申请业务员人数：{{ detail.userCount }}人</span>
          <span style="margin-left: 20px">申请金额：{{ detail.requestAmount }}元</span>
        </div>
        <div style="margin-top: 10px">备注：</div>
        <Input type="textarea" v-model="detail.remark" placeholder="请输入" />
      </div>
      <div class="ivu-modal-footer">
        <Button :disabled="detail.userCount == 0" type="text" @click="auditReject()">驳回</Button>
        <Tooltip v-if="$units.isOkBao() && detail.checkCount > 10" placement="top" content="打款一次性不能超过十条！">
          <Button style="marigin-left: 10px" :disabled="detail.userCount == 0" type="primary" @click="auditPass">审核通过</Button>
        </Tooltip>
        <Button v-else :disabled="detail.userCount == 0" type="primary" @click="auditPass">审核通过</Button>
      </div>
    </Modal>
    <Modal v-model="showPaymentTimeModal" title="打款时间" :mask-closable="false" :footer-hide="true" width="500px" class="my-modal top">
      <div class="confirm-box">
        <span style="margin-right: 10px">打款时间</span>
        <DatePicker type="date" transfer v-model.trim="detail.paymentTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
      </div>
      <div class="ivu-modal-footer">
        <Button :disabled="detail.userCount == 0" type="text" @click="confirm(1)">取消</Button>
        <Button :disabled="detail.userCount == 0" type="primary" @click="confirm(2)">确定</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import filter from '@/api/filter';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  components: {
    confirmModal,
  },
  data() {
    return {
      visible: false,
      tableData: [],
      params: {},
      detail: {
        remark: '', //备注
        paymentTime: '' //打款时间
      },
      loading: false,
      showPaymentTimeModal: false //打款时间弹窗
    };
  },
  computed: {},
  methods: {
    // 驳回
    auditReject() {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '确定驳回？'
        })
        .then(() => {
          this.save(2);
        });
    },
    // 审核通过
    auditPass() {
      this.visible = false;
      this.showPaymentTimeModal = true;
    },
    confirm(type) {
      if (type == 1) {
        this.detail.paymentTime = '';
        this.showPaymentTimeModal = false;
      } else if (this.detail.paymentTime) {
        this.detail.paymentTime = filter.filterTime(this.detail.paymentTime, 'YYYY-MM-DD');
        if (type == 2) {
          this.save(1);
        }
      } else {
        this.$notice.msg('请选择打款日期');
      }
    },

    // 提交
    save(checkStatus) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: '/buz/userCashWithdrawLog/batchCheck',
        type: 'POST',
        data: {
          ...this.params,
          checkStatus,
          remark: this.detail.remark,
          paymentTime: this.detail.paymentTime,
          idempotentId: this.detail.idempotentId
        }
      })
        .then(res => {
          this.$Message.success('操作成功');
          this.$emit('success');
          this.showPaymentTimeModal = false;
          this.visible = false;
          window.setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch(() => {
          window.setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    open(params, tableData) {
      this.tableData = tableData;
      this.params = JSON.parse(JSON.stringify(params));
      const list = tableData.filter(item => {
        return this.params.idList.includes(item.id) && item.status == 9;
      });
      // 勾选了银行处理中报错
      if (list && list.length > 0) {
        this.$notice.msg('银行处理中不能操作驳回或者打款');
        return;
      }
      this.$http({
        url: '/buz/userCashWithdrawLog/preBatchCheck',
        type: 'POST',
        data: params
      }).then(res => {
        if (res.data) {
          this.detail = res.data;
          this.visible = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
  /deep/.ivu-tooltip-rel {
    .ivu-btn {
      margin-left: 10px;
    }
  }
}
</style>
